import Comjs from "@/assets/js/common.js";
import axios from "axios";
const token = 'e49781d8-8612-4ff7-a083-9fffd95a0cc9' // 由销售通提供，目前不变
const casApiURL = process.env.VUE_APP_DIP_API_URL;
import { getModernOSInfo } from "@/assets/js/util.js";

const user = {
  namespaced: true,
  state: {
    dealer: Comjs && Comjs.getLoginInfo() ? Comjs.getLoginInfo().profile : "",
    osInfo: {}
  },

  mutations: {
    setOsInfo(state, data) {
      state.osInfo = data
    }
  },

  actions: {    // 判断当前登录门店是否灰度
    getDealerCodeGray({}, data) {
      const { dealerCode, dealerNet } = data
      return new Promise((resolve, reject) => {
        const params = {
          dealerCode: dealerCode,
          net: dealerNet
        }
        const TIMESTAMP =  Date.now() // 当前的时间戳
        const SIGN = Comjs.md5(`TIMESTAMP=${TIMESTAMP}&dealerCode=${dealerCode}&net=${dealerNet}&OPENTOKEN=${token}`).toString().toUpperCase() 
        const config = {
          timeout: 10000, // 设置请求超时时间默认 10 秒
          headers: {
            TIMESTAMP, // 时间戳
            SIGN //签名
          }
        }
        axios.post(`${casApiURL}/dip/api/nsys/apiManagement/MH/post/COM_GRAY`, params, config).then(res=>
          {
            resolve(res)
          }
        ).catch(err=>{ reject(err) })
      })
    },
    getModernOSInfo({commit},) {
      return new Promise((resolve, reject) => {
        getModernOSInfo().then(osInfo => {
          // console.log("操作系统信息:");
          // console.log(`名称: ${osInfo.name}`);
          // console.log(`版本: ${osInfo.version}`);
          // console.log(`版本名称: ${osInfo.versionName}`);
          // console.log(`完整版本: ${osInfo.fullVersion}`);
          commit('setOsInfo', osInfo)
          resolve(osInfo)
        });
       })
    }
  },
  getters: {
    osInfo: state => state.osInfo,
    dealer: state => state.dealer,
  }
};

export default user;
